import type { WebLocale } from '@/enums/web-locale';

import { COUNTRY_EXCEPTIONS, WEB_LOCALES } from '@/constants/web-locales.constant';

import { OnboardingStatus } from '@/enums/onboarding-status';
import { useUserStore } from '@/stores/pinia/useUserStore';

export function getOnboardingStatus(
	detectedWebLocale: WebLocale,
	isLoggedIn: boolean,
	pathname?: string
): OnboardingStatus {
	// Default to GLOBAL
	let status: OnboardingStatus = OnboardingStatus.GLOBAL;
	const isHomeUrl = pathname === '/';

	if (isHomeUrl && !isSupportedCountry(detectedWebLocale)) {
		status = OnboardingStatus.UNSUPPORTED_COUNTRY;
	} else if (detectedWebLocale && !isLoggedIn) {
		status = OnboardingStatus.GLOBAL;
	} else if (isLoggedIn) {
		status = OnboardingStatus.SIGNED_UP;
	}

	return status;
}

function isSupportedCountry(detectedWebLocale: WebLocale) {
	const availableCountries = Object.values(WEB_LOCALES).map(webLocale =>
		webLocale.substring(webLocale.length - 2).toLowerCase()
	);

	const isCountrySupported = availableCountries.includes(detectedWebLocale);
	const isCountryException = Object.values(COUNTRY_EXCEPTIONS).includes(detectedWebLocale);

	return isCountrySupported || isCountryException;
}

export function loadOnBoardingStatus(webLocale: WebLocale, url: string) {
	const userStore = useUserStore();
	const isLoggedIn = userStore.isLoggedIn;
	const onboardingStatus = getOnboardingStatus(webLocale, isLoggedIn, url);

	userStore.saveOnboardingStatus(onboardingStatus);
}
